import { render, staticRenderFns } from "./VirtualAccountDetail.vue?vue&type=template&id=b7b62e00&scoped=true"
import script from "./VirtualAccountDetail.vue?vue&type=script&lang=js"
export * from "./VirtualAccountDetail.vue?vue&type=script&lang=js"
import style0 from "./VirtualAccountDetail.vue?vue&type=style&index=0&id=b7b62e00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b62e00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7b62e00')) {
      api.createRecord('b7b62e00', component.options)
    } else {
      api.reload('b7b62e00', component.options)
    }
    module.hot.accept("./VirtualAccountDetail.vue?vue&type=template&id=b7b62e00&scoped=true", function () {
      api.rerender('b7b62e00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VirtualAccount/VirtualAccountDetail.vue"
export default component.exports